import axios from "axios";
import store from '../stores/store'
import router from '../routes/router'
import Vue from "vue"
const service = axios.create({
  baseURL:"",
  // timeout: 1000 * 60 * 1, //分钟
  headers: {
    "Content-Type": "application/json"
  },
});

if(process.env.NODE_ENV === 'production') {
  // service.defaults.baseURL = config.httpUrl
  if(window.location.protocol == 'http:') {
    service.defaults.baseURL = 'http://nhcisc.com/nhomr'
  } else {
    service.defaults.baseURL = 'https://nhcisc.com/nhomr'
  }
} else {
	// service.defaults.baseURL = 'http://192.168.0.118:801/ydj/nhomr'
  service.defaults.baseURL = 'http://192.168.0.128:801/tfpt/nhomr'
}

// 响应拦截
service.interceptors.response.use(
  response => {
      if (response.data.code == 301) {
        Vue.prototype.$message({
          showClose: true,
          type: "warning",
          message: '登录超时，请重新登录！'
        });
        localStorage.removeItem("ydjloginInfo");
        localStorage.removeItem("ydj_token");
        // router.push("/login");
        // Vue.prototype.$alert('登录超时，请重新登录！', '提示', {
        //   confirmButtonText: '确定',
        //   customClass: 'confirmTips',
        //   callback: action => {
            // store.dispatch('isLoginChange',false)
            // localStorage.removeItem("zzmanageloginInfo");
            // router.push("/login");
        //   }
        // });
      } 
      return response;
  },
  err => {
    if (err.response) {
      if (err.response.code == 301) {
        // 返回 401 跳转到登录页面
        Vue.prototype.$alert('登录超时，请重新登录！', '提示', {
          confirmButtonText: '确定',
          customClass: 'confirmTips',
          callback: action => {
            localStorage.removeItem("ydjloginInfo");
            localStorage.removeItem("ydj_token");
            // router.push("/login");
          }
        });
        return;
      }
    }
    return Promise.reject(err); // 返回接口返回的错误信息
  }
);

export default service;
